import React from 'react';
interface ProductItem {
  item: string;
  description?: string;
  unit: number;
  unitPrice: number;
  discount?: number;
  amount: number;
}
interface PaxStatementProductsProps {
  items: ProductItem[];
  totals: {
    subtotal: number;
    totalDiscount: number;
    totalGST: number;
    grandTotal: number;
    currency: string;
  };
}
export function PaxStatementProducts({
  items,
  totals
}: PaxStatementProductsProps) {
  const formatCurrency = (amount: number) => {
    return `${totals.currency} ${amount.toFixed(2)}`;
  };
  const formatDiscount = (discount?: number) => {
    if (!discount || discount === 0) {
      return '—';
    }
    return `–${formatCurrency(Math.abs(discount))}`;
  };
  return <div className="mb-6" data-id="element-820">
      <h3 className="text-sm font-bold text-neutral-900 uppercase tracking-wide mb-4 pb-2 border-b-2 border-neutral-300" data-id="element-821">
        Product & Services
      </h3>

      {/* Table */}
      <div className="border border-neutral-200 rounded-lg overflow-hidden mb-4" data-id="element-822">
        <table className="w-full text-xs" data-id="element-823">
          <thead className="bg-neutral-50 border-b border-neutral-200" data-id="element-824">
            <tr data-id="element-825">
              <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-826">
                Item
              </th>
              <th className="text-center font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-827">
                Unit
              </th>
              <th className="text-right font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-828">
                Unit Price
              </th>
              <th className="text-right font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-829">
                Discount
              </th>
              <th className="text-right font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-830">
                Amount
              </th>
            </tr>
          </thead>
          <tbody data-id="element-831">
            {items.map((item, index) => <tr key={index} className="border-b border-neutral-200 last:border-b-0" data-id="element-832">
                <td className="px-3 py-2.5" data-id="element-833">
                  <p className="font-semibold text-neutral-900" data-id="element-834">{item.item}</p>
                  {item.description && <p className="text-neutral-600 text-xs mt-0.5" data-id="element-835">
                      {item.description}
                    </p>}
                </td>
                <td className="px-3 py-2.5 text-center text-neutral-900" data-id="element-836">
                  {item.unit}
                </td>
                <td className="px-3 py-2.5 text-right text-neutral-900 tabular-nums" data-id="element-837">
                  {formatCurrency(item.unitPrice)}
                </td>
                <td className="px-3 py-2.5 text-right text-green-600 tabular-nums" data-id="element-838">
                  {formatDiscount(item.discount)}
                </td>
                <td className="px-3 py-2.5 text-right font-semibold text-neutral-900 tabular-nums" data-id="element-839">
                  {formatCurrency(item.amount)}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Divider before totals */}
      <div className="h-px bg-neutral-200 mb-4" data-id="element-840" />

      {/* Totals */}
      <div className="flex justify-end" data-id="element-841">
        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 min-w-[320px]" data-id="element-842">
          <div className="space-y-2.5" data-id="element-843">
            <div className="flex justify-between items-center" data-id="element-844">
              <span className="text-xs font-medium text-neutral-600" data-id="element-845">
                Subtotal:
              </span>
              <span className="text-xs text-neutral-900 tabular-nums" data-id="element-846">
                {formatCurrency(totals.subtotal)}
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-847">
              <span className="text-xs font-medium text-neutral-600" data-id="element-848">
                Total Discount & Commission:
              </span>
              <span className="text-xs text-green-600 tabular-nums" data-id="element-849">
                –{formatCurrency(totals.totalDiscount)}
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-850">
              <span className="text-xs font-medium text-neutral-600" data-id="element-851">
                Total GST:
              </span>
              <span className="text-xs text-neutral-900 tabular-nums" data-id="element-852">
                {formatCurrency(totals.totalGST)}
              </span>
            </div>
            <div className="h-px bg-neutral-300" data-id="element-853" />
            <div className="flex justify-between items-center bg-blue-50 border border-blue-200 -mx-5 px-5 py-2.5 rounded" data-id="element-854">
              <span className="text-sm font-bold text-neutral-900" data-id="element-855">
                Grand Total:
              </span>
              <span className="text-base font-bold text-blue-700 tabular-nums" data-id="element-856">
                {formatCurrency(totals.grandTotal)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}